import React from 'react';
import { Layout } from '../../components/layout/Layout';
import { PageHero, ContentSection, SEOContent, CTASection } from '../../components/shared';
import { kontaktDaten } from '../../data/mock';

export const AkutsprechstundePage = () => {
  return (
    <Layout>
      <PageHero
        title="Akutsprechstunde: Schnelle Hilfe bei plötzlichen Beschwerden"
        subtitle="Wir sind für Sie da, wenn es schnell gehen muss – mit kurzfristigen Terminen für akute Fälle."
        backgroundImage="/images/Akutsprechstunden_EKG.webp"
        ctaText="Akut-Termin vereinbaren"
      />

      <ContentSection
        title="Plötzliche Beschwerden? Wir helfen sofort."
        content={
          <div className="space-y-4">
            <p className="text-[#0b382a]/80 leading-relaxed">
              Sie haben akute Schmerzen oder plötzlich auftretende Symptome, die eine sofortige ärztliche Abklärung erfordern? Unsere Akutsprechstunde ist für diese Fälle vorgesehen. Hier behandeln wir Patienten mit dringenden Beschwerden, die keine lange Wartezeit in Kauf nehmen können. Bitte beachten Sie, dass dies kein Termin für Routineuntersuchungen ist.
            </p>
            <div className="bg-[#0b382a]/5 rounded-xl p-6">
              <h4 className="font-semibold text-[#0b382a] mb-3">Zeiten der Notfallsprechstunde:</h4>
              <ul className="space-y-2 text-[#0b382a]/80">
                <li className="flex items-center gap-2">
                  <span className="w-2 h-2 bg-[#ddc57b] rounded-full"></span>
                  <strong>Montag:</strong> 08:00 – 11:00 Uhr (Nur Notfälle)
                </li>
                <li className="flex items-center gap-2">
                  <span className="w-2 h-2 bg-[#ddc57b] rounded-full"></span>
                  <strong>Dienstag bis Freitag:</strong> 08:00 – 09:00 Uhr
                </li>
              </ul>
              <p className="text-sm text-[#0b382a]/60 mt-3">Die reguläre Terminsprechstunde beginnt im Anschluss.</p>
            </div>
          </div>
        }
        image="/images/Akutsprechstunden_EKG.webp"
        backgroundColor="white"
      />

      <SEOContent
        title="Dringende Arzttermine in Diez"
        content="Bei akuten gesundheitlichen Problemen bietet Ihnen die Gemeinschaftspraxis Dres. von Bergh in Diez eine schnelle und kompetente Versorgung in der Akutsprechstunde."
      />

      <section className="py-16 bg-[#0b382a]">
        <div className="container mx-auto px-4 lg:px-8 text-center">
          <h2 className="text-2xl md:text-3xl font-semibold text-white mb-4">Sie benötigen kurzfristig ärztliche Hilfe?</h2>
          <p className="text-white/80 mb-8">Kontaktieren Sie uns oder kommen Sie direkt während unserer Akutsprechstundenzeiten vorbei.</p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a href={`tel:${kontaktDaten.telefon.replace(/\s/g, '')}`} className="inline-flex items-center gap-2 px-8 py-3 bg-[#ddc57b] hover:bg-[#c9b36d] text-[#0b382a] font-semibold rounded-full transition-colors">
              Jetzt anrufen: {kontaktDaten.telefon}
            </a>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default AkutsprechstundePage;
